<div
	class="tw-flex tw-flex-col tw-p-4 tw-text-gray-500 tw-bg-white tw-rounded-xl tw-gap-2 tw-box-border tw-cursor-pointer activity-tile"
	[ngClass]="{ 'tw-scale-backpack-pressed': pressed, 'button-pressed': buttonPressed }"
	(mousedown)="handleTilePress()"
	(mouseup)="handleTileRelease()">
	<ng-content></ng-content>
	<bp-button
		[disabled]="buttonDisabled"
		*ngIf="buttonText"
		[size]="'sm'"
		[variant]="'lightest'"
		[title]="buttonText"
		[width]="'full'"
		[shrinkOnPress]="true"
		(mousedown)="handleButtonPress($event)"
		(mouseup)="handleButtonRelease($event)"></bp-button>
</div>
